module.exports = __webpack_public_path__ + "img/east_timor.49af1a9.webp";